import axios from "axios";

import { AUTHORIZATION_HEADER_KEY } from "./constants";

const { REACT_APP_API_BASE_URL } = process.env;

export const apiClient = axios.create({
  baseURL: `${REACT_APP_API_BASE_URL}`,
  headers: {
    "ngrok-skip-browser-warning": "true",
  },
});

export const addBearerToken = (token: string) => {
  apiClient.defaults.headers.common[AUTHORIZATION_HEADER_KEY] = `Bearer ${token}`;
};

export const deleteBearerToken = () => {
  delete apiClient.defaults.headers.common[AUTHORIZATION_HEADER_KEY];
};
